import {Component, inject, OnDestroy, OnInit} from '@angular/core';

import {appRoutes} from '@numizmat/constants';
import {environment} from "@numizmat/environments";
import {PaymentSettingsApiService} from "@numizmat/services/core";
import {PaymentSettingsResponse} from "@numizmat/services-models/core";
import {JsonLdService, MetaTagService} from "@numizmat/services/common";
import {LoaderComponent, PageHeaderComponent} from "@numizmat/components";

@Component({
    selector: 'nz-terms-conditions-page',
    imports: [
        PageHeaderComponent,
        LoaderComponent
    ],
    templateUrl: './terms-conditions-page.component.html',
    styleUrl: './terms-conditions-page.component.scss'
})
export class TermsConditionsPageComponent implements OnInit, OnDestroy {
  private jsonLdService: JsonLdService = inject(JsonLdService);
  private metaTagService: MetaTagService = inject(MetaTagService);
  private paymentSettingsApiService: PaymentSettingsApiService = inject(PaymentSettingsApiService);

  protected loading: boolean = true;
  protected paymentSettings!: PaymentSettingsResponse;

  protected readonly appRoutes = appRoutes;

  public ngOnInit(): void {
    this.setSchema();
    this.setMetaTags();
    this.getPaymentSettings();
  }

  public ngOnDestroy(): void {
    this.jsonLdService.removeSchema();
  }

  private getPaymentSettings(): void {
    this.paymentSettingsApiService.getPaymentSettings().subscribe({
      next: response => {
        this.paymentSettings = response;
        this.loading = false;
      }
    })
  }

  private setSchema(): void {
    const termsConditionsSchema = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Общи условия",
      "description": "Страница с общи условия на сайта Collectoria. Информация за права и задължения на потребителите.",
      "url": `${environment.applicationDomain}/${appRoutes.termsConditions}`
    };
    this.jsonLdService.setSchema(termsConditionsSchema);
  }

  private setMetaTags(): void {
    this.metaTagService.setCanonicalUrl(`${environment.applicationDomain}/${appRoutes.termsConditions}`);
    this.metaTagService.setTitle('Общи условия | Collectoria');
    this.metaTagService.setDescription('Общи условия | Collectoria');
  }
}
